export const formatDataTypeTime = (data: Array<string | number>) => {
  const formatValue: Array<string | number | Boolean> = []
  if (!data && !Array.isArray(data)) {
    return []
  }
  data.forEach((item: any) => {
    if (!item) {
      return item
    }
    if (typeof item === 'string') {
      formatValue.push(convertTimeToNumber(item))
    } else if (isFinite(item)) {
      formatValue.push(convertNumberToTime(item))
    }
  })
  return formatValue
}
export const convertTimeToNumber = (time: string) => {
  const findColon = time.indexOf(':')
  if (!findColon) {
    return false
  }
  const hour = time.slice(0, findColon)
  const minute = time.slice(findColon + 1)
  const convertValue = parseFloat(hour) + parseFloat(minute) / 60
  return convertValue
}
export const convertNumberToTime = (item: number) => {
  const hour = Math.floor(item)
  const minute = Math.floor((item - hour) * 60)
  const value = `${hour}:${minute > 10 ? minute : `0${minute}`}`
  return value
}
export const formatData = (data: any, key: string) => {
  if (!data || !Object.keys(data).length) {
    return {}
  }
  if (key === 'warehouse') {
    Object.keys(data).forEach((item: any) => {
      if (!Object.keys(data[item]).length) {
        return null
      }
      Object.keys(data[item]).forEach((subItem: any) => {
        if (subItem === 'mainTime' || subItem === 'subTime' || subItem === 'canView') {
          return false
        }
        if (!data[item][subItem].AM.length || !data[item][subItem].PM.length) {
          return false
        }
        Object.assign(data[item][subItem], {
          ...data[item][subItem],
          AM: formatDataTypeTime(data[item][subItem].AM),
          PM: formatDataTypeTime(data[item][subItem].PM)
        })
      })
    })
  } else if (key === 'borderGate') {
    Object.keys(data).forEach((item: any) => {
      if (!Object.keys(data[item]).length) {
        return null
      }
      if (item === 'mainTime' || item === 'subTime') {
        return false
      }
      if (!data[item].AM.length || !data[item].PM.length) {
        return false
      }
      Object.assign(data[item], {
        ...data[item],
        AM: formatDataTypeTime(data[item].AM),
        PM: formatDataTypeTime(data[item].PM)
      })
    })
  }
  return data
}

export const initNodeTypeNames = () => {
  return [
    {
      value: $t('labels.nodeModule.warehouse')
    },
    {
      value: $t('labels.nodeModule.port')
    },
    {
      value: $t('labels.nodeModule.depot')
    },
    {
      value: $t('labels.nodeModule.icd')
    },
    {
      value: $t('labels.nodeModule.tollStation')
    },
    {
      value: $t('labels.parkingLot')
    },
    {
      value: $t('labels.nodeModule.borderGate')
    }
  ]
}
